import { DummyInput } from '@/components/Form'
import useUser from '@/features/users/useUser'
import { SimpleGrid } from '@chakra-ui/react'
import moment from 'moment'
import React from 'react'
import { useWatch } from 'react-hook-form'

const PRGeneralInfoSection = () => {
  const { useFetchAllUsers } = useUser()

  const { data: allUserResponse } = useFetchAllUsers({
    page: 1,
    pageSize: 0,
    sortBy: 'fullName',
    orderBy: 1,
  })

  const sales = useWatch({ name: 'createdBy' })
  const projectManager = useWatch({ name: 'manager' })
  const bookingProjectManager = useWatch({ name: 'booking.projectManager' })

  const projectStartDate = useWatch({ name: 'projectStartDate' })
  const projectEndDate = useWatch({ name: 'projectEndDate' })
  const bookingProjectStartDate = useWatch({ name: 'booking.bookingStartDate' })
  const bookingProjectEndDate = useWatch({ name: 'booking.bookingEndDate' })

  const displayManager = bookingProjectManager || projectManager
  const displayProjectStartDate = bookingProjectStartDate || projectStartDate
  const displayProjectEndDate = bookingProjectEndDate || projectEndDate

  const allUsers = Array.isArray(allUserResponse?.data) ? allUserResponse.data : []
  const salesName = allUsers.find((user) => user._id === sales)?.fullName || '(-)'
  const projectManagerName = allUsers.find((user) => user._id === displayManager)?.fullName || '(-)'

  const formatDate = (value) => {
    if (!value) return '(-)'

    const formatted = moment(value).format('DD-MMM-YYYY')
    return formatted === 'Invalid date' ? '(-)' : formatted
  }

  return (
    <SimpleGrid columns={[1, 2, 4]} spacingX="20px" spacingY="10px">
      <DummyInput label="Start Date" readOnly value={formatDate(displayProjectStartDate)} isRow />
      <DummyInput label="End Date" readOnly value={formatDate(displayProjectEndDate)} isRow />
      <DummyInput label="Sales" readOnly value={salesName} isRow />
      <DummyInput label="Project Manager" readOnly value={projectManagerName} isRow />
    </SimpleGrid>
  )
}

export default PRGeneralInfoSection
